import React, { forwardRef } from 'react';
import { VIPData, VIPForm } from './VIPForm';
import { useAddVip } from '../hooks/useAddVip';

type VIPFormAddProps = {
  eventId: string;
  onSubmit: (data: VIPData) => void;
};

export const VIPFormAdd = forwardRef((props: VIPFormAddProps, ref) => {
  const { onSubmit, eventId } = props;
  const { addVip } = useAddVip();

  const handleSubmit = async (formData: VIPData) => {
    onSubmit(formData);
    await addVip(eventId, formData);
  };

  return (
    <VIPForm
      ref={ref}
      initialData={{ title: '' }}
      onSubmit={handleSubmit}
    />
  );
});
